import { Injectable, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MapService } from 'src/app/services/map/map.service';
import { DataService } from '../../services/data/data.service';

import { PotreeCesiumViewerComponent, PotreeCesiumToolType, PotreeCloudJsData } from './potree-cesium-viewer.component';

declare var Potree;
declare var THREE;
declare var proj4;

@Injectable({
	providedIn: 'root'
})
export class PotreeCesiumViewerService {

	_viewer:any;
	_controller:PotreeCesiumViewerComponent;

	viewerIsActive$:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	_toolActive:PotreeCesiumToolType.None;
	_measurementsActive:typeof Potree.Measurement[] = [];
	activeMeasurement$: BehaviorSubject<typeof Potree.Measurement> = new BehaviorSubject({});
	
	orbitIsOn$:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	orbutIsOnSub: Subscription;

	constructor(private mapService: MapService, private dataService: DataService, private spinner: NgxSpinnerService) { }

	loadPointCloud (url:string) :Promise<PotreeCloudJsData> {
		return new Promise<PotreeCloudJsData>((resolve, reject) => {
			const loadedData = this._controller.loadPointCloud(url);
			if (loadedData) {
				this.mapService.isThreeD$.next(true);
				this.orbutIsOnSub = this.orbitIsOn$.subscribe(isOn => {
					if (isOn) {
						this._viewer.orbitControls.startAutoOrbit(0.0001);
					} else {
						this._viewer.orbitControls.stopAutoOrbit();
					}
				});
				resolve(loadedData);
			} else {
				this.orbutIsOnSub.unsubscribe();
				reject(null);
			}
		});
	}

	unloadAllPointClouds () {
		this.removeAllMeasurements();
		this._controller?.unloadAllPointClouds();
		this.viewerIsActive$.next(false);
		this.mapService.isThreeD$.next(false);
		this._viewer?.orbitControls?.stopAutoOrbit();
		if (this.orbutIsOnSub) this.orbutIsOnSub.unsubscribe();
	}

	activateTool (id) {
		this._viewer.sidebar.manualActivateTool(id);
	}

	loadMeasurements (measurements) {
		
		this.removeAllMeasurements();
		measurements.forEach(item => {
			const measure = this.createMeasure(item, item.type);
			this._viewer.scene.addMeasurement(measure);
		});
		
	}

	removeMeasurement (measurement:typeof Potree.Measurement) {
		// this._viewer.scene.removeMeasurement(measurement);
		// this._measurementsActive.splice(measurement, 1);
	}

	removeAllMeasurements () {
		this._viewer?.scene.removeAllMeasurements();
	}

	onPointCloudAdded (e) {
		
	}


	// measurement added does not mean it's completed and fixed, refer onMeasurementComplete for complete event
	onMeasurementAdded (e) {
		
	}

	onMeasurementComplete (e) {
		
		const data = this.getPointsFromLatestMeasurements();
		this.mapService.updateMeasurements3D(data);

		// handle on confirm one point measurement, then get reference images for that point
		const lastMeasurement = data[data.length - 1];
		if (lastMeasurement.type == "Point") {
			// this.spinner.show()
			// this.dataService.getReferenceImagesFromPointCloud(this.dataService.currLocation$.getValue(), [lastMeasurement.points[0].position]).subscribe(res => {
			// 	this.dataService.featureImages$.next(res[0].slice(0, 20))
			// 	// this.spinner.hide()
			// });
		}
	}

	getPointsFromLatestMeasurements () :any {
		const measurementsData = this.measurements.map(m => {
			const p = { points: m.points, type: m.name, edgeLabelsDistance: m.edgeLabelsDistance };
			return p;
		});
		return measurementsData;
	}

	simpleStringify (object) {
		var simpleObject = {};
		for (var prop in object ){
			if (!object.hasOwnProperty(prop)){
				continue;
			}
			if (typeof(object[prop]) == 'object'){
				continue;
			}
			if (typeof(object[prop]) == 'function'){
				continue;
			}
			simpleObject[prop] = object[prop];
		}
		return JSON.stringify(simpleObject); // returns cleaned up JSON
	}

	onMeasurementRemoved (e) {
		
		if (e.measurement.name == "Point") {
			
			
		}
	}

	createMeasure (data:any, type:string) :typeof Potree.Measure {
		let measure = new Potree.Measure();
		measure.name = data.type;

		switch (type) {
			case "Height":
			measure.closed = false;
			measure.showDistances = false;
			measure.showHeight = true;
			break;

			case "Distance":
			measure.closed = false;
			break;

			case "Area":
			measure.closed = true;
			measure.showArea = true;
			break;

			case "Angle":
			measure.closed = true;
			measure.showAngles = true;
			measure.showDistances = false;
			break;
			
			default:
			measure = null;
			
			break;
		}

		data.points.forEach(point => {
			const v3 = new THREE.Vector3(point.position.x, point.position.y, point.position.z);
			measure.addMarker(v3);
		});

		return measure;
	}

	set viewer (_viewer:any) {
		this._viewer = _viewer;

		// pointclouds
		this._viewer.scene.addEventListener('pointcloud_added', this.onPointCloudAdded.bind(this));

		// measurements
		this._viewer.scene.addEventListener('measurement_added', this.onMeasurementAdded.bind(this));
		this._viewer.scene.addEventListener('measurement_removed', this.onMeasurementRemoved.bind(this));
		this._viewer.addEventListener('measurement_completed', this.onMeasurementComplete.bind(this));

		
	}

	get viewer () :any {
		return this._viewer;
	}

	set controller (_controller: PotreeCesiumViewerComponent) {
		this._controller = _controller;
	}

	get controller () :PotreeCesiumViewerComponent {
		return this._controller;
	}

	get measurements () :typeof Potree.Measurement[] {
		return this._viewer.scene.measurements;
	}

 }